import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="section-type"
// Shows/hides question, game, or passage number inputs based on selected section type
export default class extends Controller {
  static targets = ["questionSet", "gameSet", "passageSet"]

  connect() {
    // Set initial state based on current selection
    this.handleChange()
  }

  handleChange() {
    const sectionType = this.element.value

    // Hide all sets first
    if (this.hasQuestionSetTarget) this.questionSetTarget.style.display = "none"
    if (this.hasGameSetTarget) this.gameSetTarget.style.display = "none"
    if (this.hasPassageSetTarget) this.passageSetTarget.style.display = "none"

    // Show the appropriate set based on section type
    if (sectionType === 'Reasoning 1' || sectionType === 'Reasoning 2') {
      if (this.hasQuestionSetTarget) this.questionSetTarget.style.display = "block"
    } else if (sectionType === 'Comp') {
      if (this.hasPassageSetTarget) this.passageSetTarget.style.display = "block"
    } else if (sectionType === 'Games') {
      if (this.hasGameSetTarget) this.gameSetTarget.style.display = "block"
    }
  }
}
